import { TableActions } from '@core/components/Table';
import { permissaoUtils } from '@core/util/permissaoUtil';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import CancelarBaixaIcon from 'app/assets/icon/cancelarBaixaIcon';
import NfIcon from 'app/assets/icon/nfIcon';
import contaReceberApi from 'app/services/api/contaReceberApi';
import { eventReactGA } from 'app/utils/analyticsUtil';
import React, { useContext, useEffect, useState } from 'react';
import { FaCloudDownloadAlt, FaFileInvoiceDollar, FaHandHoldingUsd } from 'react-icons/fa';
import { MdRepeat } from 'react-icons/md';
import { ContaReceberContext } from '../contaReceberContext';
import { ContasReceberUtil } from '../contaReceberUtils';
import { contaReceberModais } from './modal/contaReceberModais';

const ContaReceberFab = ({ onCancelarBaixa, onDelete, handleModalBaixar }) => {
  const [somatorios] = useContext(ContaReceberContext).somatorios;
  const [selecao] = useContext(ContaReceberContext).selecao;
  const [tipoSelecao] = useContext(ContaReceberContext).tipoSelecao;
  const [page] = useContext(ContaReceberContext).page;
  const [search] = useContext(ContaReceberContext).search;
  const [size] = useContext(ContaReceberContext).size;
  const [sort] = useContext(ContaReceberContext).sort;
  const [, setModal] = useContext(ContaReceberContext).modal;
  const [filtroAvancado] = useContext(ContaReceberContext).filtroAvancado;
  const [showFabNf, setShowFabNf] = useState(false);

  const handleOpenCadastrarModal = () => {
    setModal(contaReceberModais.editarContaReceber);
  };

  const importarPlanilha = () => {
    setModal(contaReceberModais.importarContaReceber);
  };

  const mostrarFabNf = async () => {
    setShowFabNf(
      !selecao.some((x) => x?.notaFiscalId === null || x?.notaFiscalId === undefined) &&
        somatorios.quantidadeSelecionadas > 0
    );
  };

  const enviarNotaFiscal = (listaUuid) => {
    eventReactGA('Conta a receber', 'Envia NF por e-mail');
    contaReceberApi.enviarNotaFiscal(listaUuid);
  };

  useEffect(() => {
    mostrarFabNf();
    // A função é recriada a cada render; incluí-la reexecutaria a busca em loop.
    // O efeito depende apenas do gatilho listado.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [somatorios]);

  const desabilitarCancelarBaixa = somatorios?.quantidadeSelecionadasArquivoRetorno > 0;

  const actions = [
    {
      icon: <MdRepeat />,
      name: 'receitasRegulares',
      tooltip: 'Receitas regulares',
      show: true,
      onClick: () => setModal(contaReceberModais.resgatarContaReceber),
    },
    {
      icon: <NfIcon x="4" y="20" size={32} />,
      name: 'notaFiscal',
      tooltip: 'Enviar NF por e-mail',
      show: showFabNf,
      onClick: () => enviarNotaFiscal(selecao.filter((x) => x.notaFiscalId).map((x) => x.notaFiscalId)),
    },
    {
      icon: <DeleteIcon />,
      name: 'excluir',
      tooltip: 'Excluir',
      show:
        ContasReceberUtil.verificarExibicaoBotaoExcluir(tipoSelecao, selecao) && permissaoUtils.contaReceber().excluir,
      onClick: () => {
        onDelete({ ...filtroAvancado, ids: selecao, q: search, tipoSelecao }, { q: search, size, sort });
      },
    },
    {
      icon: <CancelarBaixaIcon />,
      name: 'cancelarBaixa',
      tooltip: 'Cancelar baixa',
      show: ContasReceberUtil.verificarExibicaoBotaoCancelarBaixa(tipoSelecao, selecao),
      onClick: () =>
        !desabilitarCancelarBaixa &&
        onCancelarBaixa({ selecao, tipoSelecao, params: { q: search } }, { page, q: search, size, sort }),
      disabled: desabilitarCancelarBaixa && 'Somente contas baixadas manualmente podem ter baixa cancelada',
    },
    {
      icon: <FaHandHoldingUsd />,
      name: 'baixar',
      tooltip: 'Baixar',
      show: ContasReceberUtil.verificarExibicaoBotaoBaixar(tipoSelecao, selecao),
      onClick: () => {
        handleModalBaixar(selecao);
      },
    },
    {
      icon: <FaCloudDownloadAlt />,
      name: 'importar',
      tooltip: 'Importar planilha',
      show: permissaoUtils.contaReceber().cadastrar,
      onClick: importarPlanilha,
    },
    {
      icon: <AddIcon />,
      name: 'cadastrar',
      tooltip: 'Cadastrar',
      show: permissaoUtils.contaReceber().cadastrar,
      onClick: handleOpenCadastrarModal,
    },
    {
      icon: <FaFileInvoiceDollar />,
      name: 'resgatarContaReceberContrato',
      tooltip: 'Resgatar receitas',
      show: true,
      onClick: () => setModal(contaReceberModais.resgatarContaReceberContrato),
    },
  ];
  return <TableActions actions={actions} className={'stepFabContaReceber'} />;
};

export default ContaReceberFab;
